import { render, staticRenderFns } from "./AccessRight.vue?vue&type=template&id=046ab1e0&"
import script from "./AccessRight.vue?vue&type=script&lang=js&"
export * from "./AccessRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports